import { render, staticRenderFns } from "./Userdata.vue?vue&type=template&id=3ac75be1&scoped=true"
import script from "./Userdata.vue?vue&type=script&lang=js"
export * from "./Userdata.vue?vue&type=script&lang=js"
import style0 from "./Userdata.vue?vue&type=style&index=0&id=3ac75be1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac75be1",
  null
  
)

export default component.exports